import React from 'react';
import { RotateCcw, Trophy } from 'lucide-react';
interface GameOverProps {
  score: number;
  totalTime: number;
  onRestart: () => void;
}
export const GameOver: React.FC<GameOverProps> = ({
  score,
  totalTime,
  onRestart
}) => {
  const formatTime = (ms: number) => {
    const seconds = (ms / 1000).toFixed(1);
    return `${seconds}s`;
  };
  return <div className="flex flex-col items-center justify-center min-h-screen bg-slate-950 p-6 text-center" data-id="element-20">
      <Trophy className="w-24 h-24 text-yellow-400 mb-6 animate-bounce" data-id="element-21" />

      <h2 className="text-5xl md:text-7xl font-bold text-white mb-8" data-id="element-22">
        Game Over!
      </h2>

      <div className="bg-slate-900/80 border border-slate-800 rounded-3xl p-8 mb-12 w-full max-w-md shadow-2xl" data-id="element-23">
        <div className="grid grid-cols-2 gap-8" data-id="element-24">
          <div data-id="element-25">
            <p className="text-slate-400 text-lg mb-1" data-id="element-26">Levels Cleared</p>
            <p className="text-4xl font-bold text-yellow-400" data-id="element-27">{score}</p>
          </div>
          <div data-id="element-28">
            <p className="text-slate-400 text-lg mb-1" data-id="element-29">Total Time</p>
            <p className="text-4xl font-bold text-cyan-400" data-id="element-30">
              {formatTime(totalTime)}
            </p>
          </div>
        </div>
      </div>

      <button onClick={onRestart} className="group relative inline-flex items-center justify-center px-8 py-4 font-bold text-white bg-indigo-600 rounded-full overflow-hidden transition-transform hover:scale-105 active:scale-95" data-id="element-31">
        <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" data-id="element-32"></div>
        <span className="relative flex items-center gap-2 text-2xl" data-id="element-33">
          <RotateCcw className="w-6 h-6" data-id="element-34" />
          Play Again
        </span>
      </button>
    </div>;
};